import axios from "axios";
import React, { useEffect, useState } from "react";
import { Dashboard_Client_Report } from "../../Configuration/API_URL";
import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";
import $ from "jquery";
import { Client_Search } from "../../Configuration/API_URL";
import ReportTableHeader from "../../Components/ReportTables/ReportTableHeader";
import Loader from "../../Components/Common/Loader";
import MorningLimitsTable from "../../Components/ReportTables/MorningLimitsTable";
import { Constants } from "../../CommonMethhods/Constants";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import { toast } from "react-toastify";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import {
  AESEncryption,
  ApiResDecrypt,
  onlyNumber,
} from "../../CommonMethhods/CommonMethods";
import { useDebounce } from "../../Components/useDebounce";

function MorningLimitsSidebar() {
  const storeToken = localStorage.getItem("ssoToken");
  const [fileType, setFileType] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loader, setLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [clientNameError, setClientNameError] = useState(false);
  const [data, setData] = useState("");
  const [nameError, setNameError] = useState("");
  const [page, setPage] = useState(1);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [scroll, setScroll] = useState(false);
  const [clientName, setClientName] = useState("");
  const [clientCode, setClientCode] = useState("");
  const [errorResp, setErrorResp] = useState();
  const [serverError, setServerError] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [showEmailBtn, setShowEmailBtn] = useState(true);
  const [smallLoaderMail, setSmallLoaderMail] = useState(false);

  const debouncedValue = useDebounce(clientName, 1000);
   useEffect(() => {
      setLoader(true);
      handleClientName(debouncedValue);
    }, [debouncedValue]);

  useEffect(() => {
    const myYear = new Date().getFullYear();
    const newyear = `04-01-${myYear}`;
    setFromDate(newyear);
    const current = new Date();
    const date = `${
      current.getMonth() + 1
    }-${current.getDate()}-${current.getFullYear()}`;

    setToDate(date);
  }, []);

  async function searchApiDetail(e) {
    $(".write-search.morningLimit").addClass("show-result scroll-table");
    let payloadValue = {
      keyword: e.toUpperCase(),
      Status: "",
      PageNo: page,
      PageSize: 10,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getSearchDetail = await axios.post(
        Client_Search.Search_URL,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );

      const res = ApiResDecrypt(getSearchDetail?.data);

      if (res.message === "Client does not exist.") {
        setClientList([
          { clientname: "Client does not exist.", clientCode: null },
        ]);
      } else {
        if (scroll == true) {
          setClientList((prev) => {
            return [...prev, ...res.data.clients];
          });
          setErrorResp("");
          setNameError("");
          setServerError("");
        } else {
          setClientList(res.data.clients);
          setErrorResp("");
          setNameError("");
          setServerError("");
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setScrollLoader(false);
    }
  }

  function clientSet(name, code, i) {
    if (name === "Client does not exist.") {
      $(".write-search.morningLimit").addClass("show-result scroll-table");
    } else {
      $(".write-search.morningLimit").removeClass("show-result");
      setClientList([]);
      setClientName(name);
      setClientCode(code);
      setScrollLoader(false);
    }
  }

  const handleClientName = (val) => {
    setScrollLoader(false);
    setData("");
    setNameError("");
    setFileType("");
    if (val) {
      setClientList([]);
      setScroll(false);
      // let result = e.target.value.toUpperCase();
      // setClientName(result);
      if (val?.length > 3) {
        setPage(1);
        setClientList([]);
        setScroll(false);
        searchApiDetail(val);
      }
    } else {
      setData("");
      setFileType("");
      setClientList([]);
      setPage(1);
      setClientName("");
      setClientCode("");
      setScroll(false);
      $(".write-search.morningLimit").removeClass("show-result");

      // searchApiDetail("")
    }
    $(".write-search.morningLimit-li").click(function () {
      $(".write-search.morningLimit").addClass("show-result scroll-table");
    });
  };

  const handleScroll = async () => {
    setScroll(true);
    const a = document.querySelector("#morninglimit-scroll");
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
      setPage((prev) => prev + 1);
      setScrollLoader(true);

      searchApiDetail(clientName);
    }
  };
  //search api end
  const getMorningLimitReport = async () => {
    setLoader(true);
    if (fileType == "excel") {
      setSmallLoaderExcel(true);
      setSmallLoaderPdf(false);
      setSmallLoaderMail(false);
      setLoader(false);
    } else if (fileType == "pdf") {
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(true);
      setSmallLoaderMail(false);
      setLoader(false);
    } else if (fileType == "mail") {
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setSmallLoaderMail(true);
      setLoader(false);
    } else {
      setSmallLoaderMail(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
    }
    let payloadValue = {
      clientCode: clientCode,
      fileType: fileType,
      seg: "stocks",
      mobileNo: mobileNo,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axios.post(
        Dashboard_Client_Report.MorningLimitReport_URL,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(getDetails?.data);

      if (res?.data) {
        if (fileType == "grid") {
          setData(res?.data);
        } else if (fileType == "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        } else if (fileType == "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        } else {
          toast.success("Mail sent successfully");
        }
      } else {
        setData([]);
        if (fileType == "excel") {
          toast.error("Morning Limit Report does not exist.");
        } else if (fileType == "pdf") {
          toast.error("Morning Limit Report does not exist.");
        } else if (fileType == "mail") {
          toast.error("Morning Limit Report does not exist.");
        }
      }
      // if (fileType == "grid") {
      //   setData(res);
      // } else if (fileType == "excel") {
      //   window.open(res, "_self", "noopener,noreferrer");
      // } else if (fileType == "pdf") {
      //   window.open(res, "_blank", "noopener,noreferrer");
      // }
      // else if (fileType == "mail") {
      //   toast.success("Mail sent successfully")
      // }
      // else {
      //   setData([]);
      //   if (fileType == "excel") {
      //     toast.error("Morning Limit Report does not exist.");
      //   } else if (fileType == "pdf") {
      //     toast.error("Morning Limit Report does not exist.");
      //   } else if (fileType == "mail") {
      //     toast.error("Morning Limit Report does not exist.");
      //   }
      // }
      setClientNameError(false);
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setSmallLoaderMail(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setSmallLoaderMail(false);

      setServerError("Something went wrong, Please try again later.");
      if (fileType == "excel") {
        toast.error("Something went wrong, Please try again later.");
      }
      if (fileType == "pdf") {
        toast.error("Something went wrong, Please try again later.");
      }
      if (fileType == "mail") {
        toast.error("Something went wrong, Please try again later.");
      }
    }
  };

  function clientSet(name, code, i) {
    if (name === "Client does not exist.") {
      $(".write-search.morningLimit").addClass("show-result scroll-table");
    } else {
      $(".write-search.morningLimit").removeClass("show-result");
      setClientList([]);
      setClientName(name);
      setClientCode(code);
    }
  }
  const handleOnClick = (e) => {
    if (clientName !== "" || mobileNo !== "") {
      setClientNameError(false);
      if (e.target.value) {
        setFileType(e.target.value);
      }
    } else {
      setClientNameError(true);
      // setNameError("Please give atleast one input!!!");
      toast.error("Please give atleast one input!!!");
    }
  };

  const handeleOnchange = (e) => {
    setMobileNo(e.target.value);
  };
  useEffect(() => {
    if (fileType != "") {
      getMorningLimitReport();
    }
  }, [fileType]);

  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content" className="reports">
        <div className="card-box">
          <div>
            <h2 className="report-title">{Constants.Morning_Limit_Report}</h2>
          </div>

          <div className="row input-field-wrapper">
            <div className="col-md-4 col-sm-6">
              <div className="form-group">
                <label className="form-label">{Constants.Client_Name}</label>
                <div className="input-text-wrapper align-items-center">
                  <input
                    id="input1"
                    type="text"
                    className="input-text form-control"
                    placeholder="Search by Name/ Code"
                    value={clientName}
                    // required
                    // onChange={(e) => {
                    //   searchCardDetail(e);
                    //   handleClientName(e);
                    // }}
                    onChange={(e) => {
                      setClientName(e.target.value.toUpperCase());
                      // handleClientName(e);
                    }}
                    onInput={(e) => {
                      const start = e.target.selectionStart;
                      const end = e.target.selectionEnd;
                      let input = e.target.value;
                      input = input
                          .toUpperCase()
                          .replace(/[^A-Z0-9\s]/g, "")
                          .replace(/\s+/g, " ")
                          .trimStart()
                          .slice(0, 100);

                      e.target.value = input;
                      e.target.setSelectionRange(start, end);
                  }}
                  />

                  <ul
                    className="write-search morningLimit border-0"
                    id="morninglimit-scroll"
                    onScroll={handleScroll}
                  >
                    {clientList.map((item, i) => (
                      <li
                        key={i}
                        onClick={() =>
                          clientSet(item.clientname, item.clientCode, i)
                        }
                      >
                        <div> {item.clientname}</div>
                        <div>{item.clientCode}</div>
                      </li>
                    ))}
                    {scrollLoader && (
                      <div className="loader-center">
                        <LoaderForSearch />
                      </div>
                    )}
                  </ul>
                </div>
                <span className="to-date-error">{nameError}</span>
              </div>
            </div>
            <div className="col-md-3 col-sm-3 col-6">
              <div className="form-group">
                <label className="form-label">Mobile No.: </label>
                <div className="input-text-wrapper align-items-center">
                  <input
                    type="text"
                    name="search-text"
                    id="SearchInput"
                    className="input-text form-control"
                    placeholder="Client Mobile No."
                    autoComplete="off"
                    maxLength={10}
                    onChange={handeleOnchange}
                    onInput={onlyNumber}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="text-center search-btn-wrapper">
            <button
              value="grid"
              className="send-message"
              onClick={handleOnClick}
            >
              {Constants.Search}
            </button>
          </div>
          <div>
            {" "}
            <ReportTableHeader
              smallLoaderMail={smallLoaderMail}
              showEmailBtn={showEmailBtn}
              smallLoaderExcel={smallLoaderExcel}
              smallLoaderPdf={smallLoaderPdf}
              handleOnClick={handleOnClick}
            />
          </div>
          <div className="for-grid-section">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : data ? (
              <div>
                <MorningLimitsTable data={data} />
              </div>
            ) : serverError ===
              "Something went wrong, Please try again later." ? (
              <h4 className="report-error-message">{serverError}</h4>
            ) : (
              ""
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default MorningLimitsSidebar;
